export default __webpack_public_path__ + "static/media/discord.b0799ae6.png";